import React from 'react'
import { SanityBusinessLines } from '../../../../../types/generated/graphql-types'
import { useTranslations } from '../../../../hooks/useTranslations'
import { mapSanityBusinessLineToInvestmentStrategyItemProps } from '../../../../mapping/InvestmentStrategiesMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { notEmpty } from '../../../../utilities/filters'
import { InvestmentStrategies } from '../../../blocks/InvestmentStrategies'
import { Section } from '../../../Section'

export type BusinessLinesSerializerProps = SanityBusinessLines & BlockWithId

export const BusinessLinesSerializer = ({
  id,
  ...props
}: BusinessLinesSerializerProps) => {
  const translations = useTranslations()

  return (
    <Section id={id}>
      <InvestmentStrategies
        items={
          props.businessLines
            ?.filter(notEmpty)
            ?.map(line =>
              mapSanityBusinessLineToInvestmentStrategyItemProps(line, translations)
            ) ?? []
        }
        title={translations.businessLines ?? undefined}
      />
    </Section>
  )
}
